import Intro from "@/components/intro";
import { PALO_ALTO_CONSTANTS } from "./constants";

const PaloAltoSdn = () => {
  return <Intro {...PALO_ALTO_CONSTANTS} />;
};

export default PaloAltoSdn;
